import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { getAuth } from 'firebase/auth'
import { loadLegacyFirestore } from 'shared/firebase/loadLegacyFirebase'
import { backendForFirebaseUser } from './backendForFirebaseUser'
import { createIdempotencyKey } from './createIdempotencyKey'

export const premiumActivationMessage =
    'Пока оплата не работает — Premium уже подключён!'

export const activateCurrentPremium = async (
    idempotencyKey = createIdempotencyKey('premium')
) => {
    const user = getAuth(app).currentUser
    const backend = backendForFirebaseUser(user)
    if (backend) {
        return backend.activatePremium(idempotencyKey)
    }

    if (!user?.uid) {
        throw new Error('Firebase authentication is required')
    }

    const { db, doc, updateDoc } = await loadLegacyFirestore()
    await updateDoc(doc(db, 'Auth', user.uid), { isPremium: true })
    return { isPremium: true }
}
